import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { appConfig } from 'src/config/appConfig';

export interface RuneToken {
  id: string;
  name: string;
  symbol: string;
  imageUrl: string;
  balance: number;
  marketPriceSats: number;
  marketPriceBtc: number;
  volume1dBtc: number;
}

export function useRunes(walletAddress: string | undefined) {
  const [tokens, setTokens] = useState<RuneToken[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTokens = useCallback(async () => {
    if (!walletAddress) {
      setTokens([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.get(`${appConfig.serviceUrl}/runes/balances`, {
        params: {
          ownerAddress: walletAddress,
          limit: 60,
          offset: 0,
        },
      });

      const items: RuneToken[] = (response.data.tokens || []).map((item: any) => ({
        id: item.id,
        name: item.name || '',
        symbol: item.symbol || '',
        imageUrl: item.imageUrl || '',
        balance: item.balance ?? 0,
        marketPriceSats: item.marketPriceSats ?? 0,
        marketPriceBtc: item.marketPriceBtc ?? 0,
        volume1dBtc: item.volume1dBtc ?? 0,
      }));

      setTokens(items);
    } catch (err: any) {
      setError(err.message || 'Failed to fetch runes');
    } finally {
      setIsLoading(false);
    }
  }, [walletAddress]);

  useEffect(() => {
    fetchTokens();
  }, [fetchTokens]);

  return { tokens, isLoading, error, refetch: fetchTokens };
}
